import Api from 'core/services/api'
import { getSummaryBySkuRequest, getSummaryBySkuResponse } from 'core/services/models'

const path = '/v1/stocks'

export const getSummaryBySku = ({ sku, params = {} }: getSummaryBySkuRequest) => {
  return Api.get<getSummaryBySkuResponse>(`${path}/${sku}/summary`, { params })
}
